export const imageBreakpoints = () => {
    return {
        jpeg: {
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1276,
            '2xl': 1386,
            '3xl': 1686,

        },
        webp: {
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1276,
            '2xl': 1386,
            '3xl': 1686,
        }
    }
};
